import { useScrollBottom } from 'hooks/useScrollToBottom';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import {
  CheckboxesWithAnswers,
  CheckBoxContainer,
  ContainerWithQuestionsAndAnswers,
  Form,
  InputCheckbox,
  QuestionText,
  LabelText,
  CheckboxContainer,
  TextArea,
} from './styled';

export const CheckboxStep = ({
  currentQuestion,
  generateAnswersObject,
  answerItem,
}) => {
  const OtherType = 'Other';
  const [showTextField, setShowTextField] = useState(false);
  const [textFieldValue, setTextFieldValue] = useState('');

  const [scrollRef, scrollToBottom] = useScrollBottom();

  const generateObject = (val) => {
    let selectedAnswers = [];
    if (answerItem?.selectedAnswers?.includes(val)) {
      selectedAnswers = answerItem.selectedAnswers.filter((item) => item !== val);
    } else {
      selectedAnswers = answerItem?.selectedAnswers
        ? [...answerItem.selectedAnswers, val]
        : [val];
    }

    return {
      position: currentQuestion.position,
      question: currentQuestion.question,
      selectedAnswers,
    };
  };

  const handleInputChange = (e) => {
    if (e.target.value !== OtherType) {
      generateAnswersObject(generateObject(e.target.value));
    } else {
      setShowTextField(!showTextField);
      if (showTextField) {
        setTextFieldValue('');
        const updateSelectAnswer = answerItem?.selectedAnswers?.filter(
          (item) => !item.includes(OtherType),
        );

        if (updateSelectAnswer !== undefined) {
          generateAnswersObject({
            position: currentQuestion.position,
            question: currentQuestion.question,
            selectedAnswers: updateSelectAnswer,
          });
        }
      } else {
        scrollToBottom();
      }
    }
  };

  const onChangeInput = (e) => {
    setTextFieldValue(e.target.value);
    const otherValue = `${OtherType}: ${e.target.value}`;
    if (answerItem?.selectedAnswers !== '' && answerItem?.selectedAnswers?.length) {
      const initialAnswer = answerItem?.selectedAnswers
        ?.map((item) => {
          if (item.includes(OtherType)) {
            return otherValue;
          }
          return item;
        })
        ?.filter((elem) => {
          if (elem.includes(OtherType)) {
            const otherValue = elem.split(': ');
            if (otherValue[1]) {
              return true;
            }
            return false;
          }
          return true;
        });

      const isOtherValue = initialAnswer?.find(
        (item) => item.includes(OtherType) && item.split(': ')?.[1],
      );

      generateAnswersObject({
        position: currentQuestion.position,
        question: currentQuestion.question,
        selectedAnswers:
          e.target.value && !isOtherValue
            ? [...initialAnswer, otherValue]
            : initialAnswer,
      });
    } else {
      generateAnswersObject({
        position: currentQuestion.position,
        question: currentQuestion.question,
        selectedAnswers: e.target.value ? [otherValue] : '',
      });
    }
  };

  useEffect(() => {
    const OtherTypeValue = answerItem?.selectedAnswers?.filter((elem) =>
      elem.includes(OtherType),
    );

    if (OtherTypeValue?.length) {
      setShowTextField(true);
      setTextFieldValue(OtherTypeValue[0].split(': ')?.[1]);
    } else {
      setShowTextField(false);
      setTextFieldValue('');
    }
  }, [answerItem?.position]);

  return (
    <CheckBoxContainer>
      <ContainerWithQuestionsAndAnswers>
        <QuestionText>{currentQuestion.question}</QuestionText>
        <CheckboxesWithAnswers ref={scrollRef}>
          {currentQuestion.answer.map((item) => (
            <Form key={uuid()}>
              <CheckboxContainer>
                <InputCheckbox
                  checked={answerItem?.selectedAnswers?.includes(item.value)}
                  onChange={handleInputChange}
                  value={item.value}
                  type="checkbox"
                  id={uuid()}
                  name="checkbox"
                />
              </CheckboxContainer>
              <LabelText>{item.label}</LabelText>
            </Form>
          ))}
          {currentQuestion?.is_other_present ? (
            <>
              <Form key={uuid()}>
                <CheckboxContainer>
                  <InputCheckbox
                    checked={showTextField}
                    onChange={handleInputChange}
                    value={OtherType}
                    type="checkbox"
                    id={uuid()}
                    name="checkbox"
                  />
                </CheckboxContainer>
                <LabelText>{OtherType}</LabelText>
              </Form>
              {showTextField ? (
                <TextArea
                  name="textfield"
                  value={textFieldValue}
                  onChange={onChangeInput}
                />
              ) : null}
            </>
          ) : null}
        </CheckboxesWithAnswers>
      </ContainerWithQuestionsAndAnswers>
    </CheckBoxContainer>
  );
};
